import { API_URL, GETAPI } from "./config";

export const ADD_CITIES = async (city_ids, users_role_id) => {
  const res = await GETAPI(
    API_URL.addCities,
    "&city_ids=" + city_ids + "&users_role_id=" + users_role_id
  );
  return res;
};
